export const MEGA_HEADER_MODULE = {
  POPULARITY_ICON_SIZE: 14,
  DESCRIPTION_TOOLTIP_WIDTH: 288,

  ACTION_TYPES: {
    tabClick: 'tabClick'
  },
}